export default "__VITE_ASSET__5DDZgpee__"